const AppStyles = {
  LargeTitle1: {
    fontSize: '32px',
    fontWeight: '700',
    lineHeight: '40px',
    fontStyle: 'normal'
  },
  LargeTitle2: {
    fontSize: '30px',
    fontWeight: '700',
    lineHeight: '40px',
    fontStyle: 'normal'
  },
  LargeTitle3: {
    fontSize: '28px',
    fontWeight: '700',
    lineHeight: '36px',
    fontStyle: 'normal'
  },
  Title1: {
    fontSize: '20px',
    fontWeight: '700',
    lineHeight: '32px',
    fontStyle: 'normal'
  },
  Title2: {
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: '24px',
    fontStyle: 'normal'
  },
  Title3: {
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '24px',
    fontStyle: 'normal'
  },
  Title4: {
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '24px',
    fontStyle: 'normal'
  },
  // BODY
  Subheading1: {
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '24px',
    fontStyle: 'normal'
  },
  Subheading2: {
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '20px',
    fontStyle: 'normal'
  },
  Body: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '20px',
    fontStyle: 'normal'
  },
  BodyBold: {
    fontSize: '12px',
    fontWeight: '700',
    lineHeight: '20px',
    fontStyle: 'normal'
  },
  BodyLink: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '20px',
    fontStyle: 'normal',
    textDecoration: 'underline'
  },
  BodyLinkBold: {
    fontSize: '12px',
    fontWeight: '700',
    lineHeight: '20px',
    fontStyle: 'normal',
    textDecoration: 'underline'
  },
  Caption1: {
    fontSize: '10px',
    fontWeight: '700',
    lineHeight: '16px',
    fontStyle: 'normal',
    letterSpacing: '2px',
    textTransform: 'uppercase'
  },
  Caption2: {
    fontSize: '8px',
    fontWeight: '900',
    lineHeight: '16px',
    fontStyle: 'normal',
    letterSpacing: '2px'
  },
  Caption3: {
    fontSize: '12px',
    fontWeight: '700',
    lineHeight: '16px',
    fontStyle: 'normal'
  },
  Caption4: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '16px',
    fontStyle: 'normal'
  },
  ButtonLarge: {
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '24px',
    fontStyle: 'normal'
  },
  ButtonMedium: {
    fontSize: '12px',
    fontWeight: '700',
    lineHeight: '24px',
    fontStyle: 'normal'
  },
  ButtonSmall: {
    fontSize: '10px',
    fontWeight: '500',
    lineHeight: '16px',
    fontStyle: 'normal'
  },

  TabbarActive: {
    fontSize: '10px',
    fontWeight: '500',
    lineHeight: '16px',
    fontStyle: 'normal'
  },
  TabbarInActive: {
    fontSize: '10px',
    fontWeight: '400',
    lineHeight: '16px',
    fontStyle: 'normal'
  },
  SegmentedActive: {
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '16px',
    fontStyle: 'normal'
  },
  SegmentedInActive: {
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '16px',
    fontStyle: 'normal'
  }
};

export { AppStyles };
